import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Header, Menu, NavigationMenu, Profile, Text } from '@poliedro/tamentai';

import { deleteChatsDatabase } from '../../services/indexeddb/index';
import { useProfileData } from '../../services/useProfileData/index';
import { RootState } from '../../store';
import { resetProfile } from '../../store/profileSlice';
import BreadCrumb from '../BreadCrumb';

interface MainHeaderProps {
  name: string;
  userProfile: string;
}

const MainHeader = ({ name, userProfile }: MainHeaderProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userData } = useProfileData(true);
  const profile = useSelector((state: RootState) => state.profile.profileData);
  const profileAvatar = profile?.foto;

  const canSwitchProfile =
    !!userData &&
    (userData.schools.length > 1 ||
      userData.schools.some(school => (school.profile?.length ?? 0) > 1));

  return (
    <Header.Root>
      <Header.Title text="Cosmos" />

      <Header.Content>
        <NavigationMenu.Root>
          <NavigationMenu.Trigger>
            <Profile.Root>
              <Profile.Avatar image={profileAvatar ? profileAvatar : ''} />

              <Profile.Infos>
                <Profile.Name text={name} />
                <Profile.Office text={userProfile} />
              </Profile.Infos>

              <Profile.Arrow />
            </Profile.Root>
          </NavigationMenu.Trigger>

          <NavigationMenu.Content>
            <Menu.Root>
              {canSwitchProfile && (
                <Menu.Item
                  data-guard="navigate"
                  onClick={async () => {
                    if (profile) {
                      try {
                        if (profile.idEscola) {
                          sessionStorage.setItem(
                            'lastSchoolId',
                            String(profile.idEscola),
                          );
                        }
                      } catch (e) {
                        console.error(e);
                      }
                    }
                    await deleteChatsDatabase();
                    navigate('/');
                    dispatch(resetProfile());
                  }}
                >
                  <Text variant="label-lg">Trocar Perfil</Text>
                </Menu.Item>
              )}

              <Menu.Item
                data-guard="navigate"
                onClick={async () => {
                  await deleteChatsDatabase();
                  localStorage.removeItem('token');
                  dispatch(resetProfile());
                }}
              >
                <Text variant="label-lg">Sair</Text>
              </Menu.Item>
            </Menu.Root>
          </NavigationMenu.Content>
        </NavigationMenu.Root>
      </Header.Content>
      <BreadCrumb />
    </Header.Root>
  );
};

export default MainHeader;
